(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
        this.setupMobileAlwaysSticky();
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);

      if (this.mobileStickyResizeHandler) {
        window.removeEventListener('resize', this.mobileStickyResizeHandler);
      }

      if (this.mobileStickyPlaceholder) {
        this.mobileStickyPlaceholder.remove();
      }
    }

    setupMobileAlwaysSticky() {
      this.mobileStickyMedia = window.matchMedia('(max-width: 749px)');
      this.mobileStickyPlaceholder = document.createElement('div');
      this.mobileStickyPlaceholder.className = 'mobile-sticky-header-placeholder';
      this.mobileStickyPlaceholder.setAttribute('aria-hidden', 'true');
      this.header.insertAdjacentElement('afterend', this.mobileStickyPlaceholder);

      this.mobileStickyTop = this.header.getBoundingClientRect().top + window.scrollY;

      this.mobileStickyResizeHandler = () => {
        if (!this.header.classList.contains('mobile-always-fixed')) {
          this.mobileStickyTop = this.header.getBoundingClientRect().top + window.scrollY;
        }

        this.updateMobileAlwaysSticky();
      };

      window.addEventListener('resize', this.mobileStickyResizeHandler, { passive: true });
      requestAnimationFrame(() => this.updateMobileAlwaysSticky());
    }

    updateMobileAlwaysSticky() {
      if (!this.mobileStickyMedia || !this.mobileStickyPlaceholder) return;

      const shouldFix = this.mobileStickyMedia.matches && window.scrollY >= this.mobileStickyTop;
      const headerHeight = this.header.offsetHeight;

      this.mobileStickyPlaceholder.style.setProperty('--mobile-sticky-header-height', `${headerHeight}px`);
      this.header.classList.toggle('mobile-always-fixed', shouldFix);
      this.header.classList.remove('shopify-section-header-hidden');
      this.mobileStickyPlaceholder.classList.toggle('is-active', shouldFix);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.headerIsAlwaysSticky) {
        this.updateMobileAlwaysSticky();
      }

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
